import { useEffect } from 'react';
import '../styles/Root.css';
import SiteNavbar from './Navbar';
import { Button, Grid, Typography } from '@mui/material';
import MediaCard from '../components/general/MediaCard';
import { Link } from 'react-router-dom';

export default function Root() {
    useEffect(() => {
        document.title = 'Job Apps Tracker';
    }, []);

    return (
        <div className="root-container">
            <SiteNavbar />
            <main className="root-content">
                {/* Hero Section */}
                <section className="hero-section">
                    <h1 className="hero-title">
                        <Typography
                            component="span"
                            variant="inherit"
                            className="gradient-text-primary"
                        >
                            Finally,
                        </Typography>
                        {" "} an organized job search.
                    </h1>
                    <p className="hero-subtitle">
                        Never lose track of a job application's status or its details ever again.
                    </p>
                    <div>
                        <Link to="/profile" style={{ textDecoration: 'none' }}>
                            <Button
                                variant="contained"
                                size="large"
                                className="btn-primary-cta"
                            >
                                Get Started
                            </Button>
                        </Link>
                    </div>
                </section>

                {/* Primary Features Grid */}
                <section className="feature-grid-wrapper">
                    <Grid container spacing={3} justifyContent="center" alignItems="stretch">
                        <Grid item xs={12} sm={6} md={4} display="flex">
                            <MediaCard
                                title="Drag n' Drop"
                                alt="Drag n' Drop"
                                description="Create cards for your job applications, then drag and drop them between four categories: applied, interviewing, rejected, and offer."
                                imageLink="drag_drop.png"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} display="flex">
                            <MediaCard
                                title="Made for Job Apps"
                                alt="Made for Job Apps"
                                description="Each job card contains info fields built with your job search in mind: deadlines, recruiter contact, application link, level of priority, and more!"
                                imageLink="job_app_form.png"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} display="flex">
                            <MediaCard
                                title="Share (or don't!)"
                                alt="Share (or don't!)"
                                description="Easily toggle your list between private and public: while on public, simply copy paste your job list's link to your friends, and they can view it!"
                                imageLink="public_private.png"
                            />
                        </Grid>
                    </Grid>
                </section>

                {/* AI Companion Section */}
                <section className="ai-section-wrapper">
                    <h1 className="section-title">
                        Chat with{' '}
                        <Typography
                            component="span"
                            variant="inherit"
                            className="gradient-text-frank"
                        >
                            F.R.A.N.K.
                        </Typography>
                        , your AI Companion
                    </h1>
                    <p className="section-subtitle">
                        The Friendly Robotic Assistant for Navigating_career (😉) Knowledge is here to generate content to strengthen your job applications and to answer your general questions about them.
                    </p>
                    <Grid container spacing={3} justifyContent="center" alignItems="stretch">
                        <Grid item xs={12} sm={6} md={4} display="flex">
                            <MediaCard
                                title="Query Your Job List"
                                alt="Query Your Job List"
                                description="Job lists getting too long? No problem. Ask F.R.A.N.K. for info about a specific job (or jobs based on some filtering criteria). Sadly F.R.A.N.K. is bad with deadlines, so please be understanding!"
                                imageLink="suitcase.png"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} display="flex">
                            <MediaCard
                                title="Write a Poem"
                                alt="Write a Poem"
                                description="Want help reaching out to recruiters? No problem. Ask F.R.A.N.K. to write you a follow up email for a job you've applied to, and it can create one based on the info provided in your list. If it's in the mood, it can even write you a poem!"
                                imageLink="poem.png"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} display="flex">
                            <MediaCard
                                title="Ask it Anything"
                                alt="Ask it Anything"
                                description="Have a question about your job search but don't know where to look? Google is a good place to start, but no problem! F.R.A.N.K. is a powerful generative AI that will answer all your job search related questions."
                                imageLink="thinking.png"
                            />
                        </Grid>
                    </Grid>
                </section>

                {/* Bottom Call to Action Card */}
                <section className="bottom-cta-card">
                    <Typography
                        variant="h4"
                        component="h2"
                        className="bottom-cta-title"
                    >
                        What are you waiting for?
                    </Typography>
                    <p className="bottom-cta-text">
                        Start organizing your applications and streamline your job search today.
                    </p>
                    <Link to="/profile" style={{ textDecoration: 'none' }}>
                        <Button
                            variant="contained"
                            size="large"
                            className="btn-primary-cta"
                        >
                            Get Started
                        </Button>
                    </Link>
                </section>
            </main>
        </div>
    );
}